// frontend/src/components/pages/WalletProvider.jsx
// Wraps the app with Solana Wallet Adapter providers.

import React, { useMemo } from "react";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  PhantomWalletAdapter,
  SolflareWalletAdapter,
} from "@solana/wallet-adapter-wallets";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { clusterApiUrl } from "@solana/web3.js";

// Required styles for the wallet modal UI
import "@solana/wallet-adapter-react-ui/styles.css";

const SolanaWalletProvider = ({ children }) => {
  const network = WalletAdapterNetwork.Devnet;
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  // Only use wallets that are exported by the installed version of the package.
  // BackpackWalletAdapter was removed from @solana/wallet-adapter-wallets in newer versions.
  // Phantom and Solflare are always available and support standard wallet detection.
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [network]
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      {/* WalletProvider must be inside ConnectionProvider */}
      <WalletProvider wallets={wallets} autoConnect={true}>
        {/* WalletModalProvider must wrap any component that uses WalletMultiButton */}
        <WalletModalProvider>
          {children}
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};

export default SolanaWalletProvider;
